import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface AgentV2UsersAssetsDetailResponse {
  template_detail: Array<TemplateDetail>;
  push_setting: Array<PushSetting>;
  push_setting_visibility: Array<number>
};
export interface TemplateDetail {
  id: number;
  uuid: string;
  template_name: string;
  style_model_id: string;
  actor_model_id: string;
  voice_model_id: string;
  cover_url: string;
  type: number;
  created_at: number;
  updated_at: number;
};

export interface PushSetting {
  id: number;
  user_id: number;
  agent_id: number;
  type: number;
  push_frequency_day: number;
  push_count: number;
  push_time: number;
  pre_push_time: number;
};

// 请求接口
interface AgentV2UsersAssetsDetailRequest {
  agentId: string;
  userId: string;
}

export class PushSettingData {
  @Required("Type cannot be empty")
  @IsNumber("Type must be a number")
  type: number;

  @Required("Push frequency day cannot be empty")
  @IsNumber("Push frequency day must be a number")
  pushFrequencyDay: number;

  @Required("Push count cannot be empty")
  @IsNumber("Push count must be a number")
  pushCount: number;

  @Required("Push time cannot be empty")
  @IsNumber("Push time must be a number")
  pushTime: number;

  // @Required("Pre push time cannot be empty")
  // @IsNumber("Pre push time must be a number")
  prePushTime?: number;
}

export class UsersAssetsDetailData {
  @Required("Push setting cannot be empty")
  @IsArray("Push setting must be an array")
  pushSetting: PushSettingData[];

  @Required("Push setting visibility cannot be empty")
  @IsArray("Push setting visibility must be an array")
  pushSettingVisibility: number[];
}

const transformAndValidateAgent = (
  response: AgentV2UsersAssetsDetailResponse
): UsersAssetsDetailData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, UsersAssetsDetailData);
  } catch (error) {
    console.error("Agent User data validation failed:", error.message);
    throw error;
  }
};

/** 用户详情(agent-v2)[下半部份]*/
export const agentV2UsersAssetsDetail = async ({
  agentId,
  userId
}: AgentV2UsersAssetsDetailRequest): Promise<UsersAssetsDetailData> => {
  const response = await api.post<AgentV2UsersAssetsDetailResponse>('/agent-v2/users/assets-detail', {
    agent_id: agentId,
    user_id: userId,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
